import { GearType, GearTypeKey, Upgrade } from 'types';

export const getUpgradeSupportText = (
	upgrade: Upgrade,
	showTransmissions: boolean,
	showDoors: boolean
): string => {
	const { gearType, doors } = upgrade.vehicleData;
	const transmissionText =
		showTransmissions && gearType ? GearType[gearType as GearTypeKey] || '' : '';
	const doorsText = showDoors && doors ? `${doors} deurs` : '';
	const hypenText = showTransmissions && showDoors && doorsText && transmissionText ? ' - ' : '';

	return `${transmissionText}${hypenText}${doorsText}`;
};
